/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Parameters for invoking a cleanup process on a source account
*/
export class CleanupInvokeParams {
  /**
  * List of regions to clean up. If empty, all supported regions will be cleaned up.
  */
  'regions'?: Array<string>;
  /**
  * Whether to run the cleanup process in dry run mode (doesn\'t delete any resources). Default is dry-run=true.
  */
  'dryRun'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "regions",
      "baseName": "regions",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "dryRun",
      "baseName": "dryRun",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CleanupInvokeParams.attributeTypeMap;
  }

  public constructor() {
  }
}

